import React, { useState, useEffect, useRef, useCallback } from "react";
import $ from "jquery";
import "turn.js";
import { useSwipeable, Swipeable } from "react-swipeable";
import styled from "styled-components";
import { useEventListener, useWindowSize } from "./../../hooks";
import { resizeKeepingAspect } from "./../../utils";

const MagContainer = styled.div`
    transform: scale(${(props) => props.scale}) !important;
`;

const MagazineTurnElem = (props) => {
    const { style = {}, className = "", options = {}, turnPage = -1, clickAudioHandler, disabled = false } = props;
    const [objassigned, setobjassigned] = useState(false);
    const [scale, setscale] = useState(1);

    const el = useRef(null);

    const windowsize = useWindowSize();

    useEffect(() => {
        if (el.current && objassigned) {
            const { width, height } = resizeKeepingAspect(
                { width: 1920, height: 1080 },
                { width: window.innerWidth - 32, height: window.innerHeight - 32 }
            );
            $(el.current).turn("size", width, height);
        }
    }, [windowsize]);

    useEffect(() => {
        if (el.current) {
            $(el.current).turn(Object.assign({}, options));
            setTimeout(() => {
                if (disabled) {
                    $(el.current).turn("disable", true);
                }
                setobjassigned(true);
            }, 100);
        }
    }, [el]);

    useEffect(() => {
        if (objassigned) {
            if (disabled) return;
            $(".magazine").on("wheel", function (event) {
                event = event.originalEvent;

                var data = $(this).data(),
                    flipbook = $(el.current),
                    view = flipbook.turn("view", page).filter((page) => page !== 0),
                    page = flipbook.turn("page"),
                    delay = 500; //ms

                if (typeof data.scrollTimer === "undefined") data.scrollTimer = 0;

                if (data.scrollTimer > event.timeStamp) return;

                data.scrollTimer = event.timeStamp + delay;

                if (event.deltaY > 0) page = Math.max(...view) + 1;
                if (event.deltaY < 0) page = Math.min(...view) - 1;

                page = Math.max(Math.min(flipbook.turn("pages"), page), 1);

                flipbook.turn("page", page);
            });
        }
    }, [objassigned]);

    useEffect(() => {
        console.log("turn page", turnPage);
        if (turnPage > 0 && el.current && objassigned) {
            console.log("turn page", turnPage);
            $(el.current).turn("page", turnPage);
        }
    }, [turnPage]);

    const handleMagClick = (e) => {
        if (disabled) return;
        let xpercent = (e.pageX / e.currentTarget.clientWidth) * 100;
        let ypercent = (e.pageY / e.currentTarget.clientHeight) * 100;
        // console.log(e.currentTarget.clientWidth, e.currentTarget.clientHeight, e.originalEvent.x,e.originalEvent.y);
        if (xpercent < 50) {
            turnPrev();
        } else if (xpercent > 50) {
            turnNext();
        }
    };

    const handleMagDblClick = (e) => {
        // scale===1?setscale(1.5):setscale(1);
    };

    const handleKeyDown = (event) => {
        if (disabled) return;
        if (event.keyCode === 37) {
            clickAudioHandler();
            let arr = [2, 3];
            let viewarr = $(el.current).turn("view");
            let isfirst = viewarr[0] === arr[0] && viewarr[1] === arr[1];
            if (!isfirst) $(el.current).turn("previous");
        }
        if (event.keyCode === 39) {
            clickAudioHandler();
            $(el.current).turn("next");
        }
    };

    const turnNext = () => {
        $(el.current).turn("next");
        clickAudioHandler();

    };

    const turnPrev = () => {
        let arr = [2, 3];
        let viewarr = $(el.current).turn("view");
        let isfirst = viewarr[0] === arr[0] && viewarr[1] === arr[1];
        // $(el.current).turn("previous");
        if (!isfirst) {$(el.current).turn("previous");
        clickAudioHandler();    
    }

    };

    useEventListener("keydown", handleKeyDown);

    return (
        <React.Fragment>
            <Swipeable
                onSwipedLeft={disabled ? undefined : turnNext}
                onSwipedRight={disabled ? undefined : turnPrev}
                {...{
                    delta: 10,
                    preventDefaultTouchmoveEvent: false,
                    trackTouch: true,
                    trackMouse: true,
                    rotationAngle: 0,
                }}
            >
                <MagContainer
                    className={className}
                    style={Object.assign({}, style)}
                    ref={el}
                    onClick={handleMagClick}
                    onDoubleClick={handleMagDblClick}
                    scale={scale}
                >
                    {props.children}
                </MagContainer>
            </Swipeable>
        </React.Fragment>
    );
};

export default MagazineTurnElem;
